<template>
    <div class="AdminSidebar">
        <div class="sidebar" :class="{open: isOpen}">
            <div class="header">
                <router-link to="/admin/dashboard" class="logoContainer">
                    <Logo class="white"/>
                </router-link>
            </div>

            <div class="main">
                <div class="nav">
                    <router-link
                        v-for="page in pages"
                        :key="page"
                        :to="`/admin/${page}`"
                    >
                        {{ page }}
                    </router-link>
                </div>

                <div class="nav"/>
            </div>
        </div>

        <div class="overlay" :class="{open: isOpen}" @click="toggle"></div>
    </div>
</template>

<script>
import Logo from '@/components/Logo';

export default {
    name: 'AdminSidebar',

    components: { Logo },

    data: () => ({
        isOpen: false,
        pages: [
            'dashboard',
            'companies',
        ],
    }),

    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.AdminSidebar {
    @extend %dashboard-sidebar;
}
</style>
